import { useNavigate, useParams } from "react-router-dom";
import Button from "@/components/Button";

function VideoErrorPage({ error }) {
    const { courseId, lectureId, grade } = useParams();
    const navigate = useNavigate();

    return (
        <div className="flex flex-col items-center justify-center w-full h-full gap-3 py-40 bg-white rounded-lg ">
            <img
                src="/images/SadFace.webp"
                alt="sad face if is Error"
                width="200px"
                decoding="async"
                loading="lazy"
            />
            {error?.response.status === 403 && (
                <p className="font-bold text-md lg:text-xl text-blue-color-primary">
                    لقد وصلت إلى الحد الأقصى لعدد المشاهدات
                </p>
            )}
            {error?.response.status !== 403 && (
                <p className="font-bold text-md lg:text-xl text-blue-color-primary">
                    {error.response.data.message}
                </p>
            )}
            <Button
                type="primary"
                className="mt-5 w-80"
                onClick={() =>
                    navigate(
                        `/${grade}/courses/${courseId}/lectures/${lectureId}`,
                        { replace: true }
                    )
                }
            >
                عودة
            </Button>
        </div>
    );
}

export default VideoErrorPage;
